import React from 'react';
import ReusableTabs from '../../pages/ReusableTabs';
import VehiclesAwating from './InternalTabs/VehiclesAwating';
import Analysis from './InternalTabs/Analysis';
import Received from './InternalTabs/Received';
import FlaggedModulesReview from './InternalTabs/FlaggedModules';
import FlaggedPalletAnalysis from './InternalTabs/FlaggedPalletAnalysis';
 
const PdiTabsComponent = () => {
  const tabs = [
    { label: 'Vehicles Awaiting Unloading', component: <VehiclesAwating /> },
    { label: 'Flagged Pallet Analysis', component: <FlaggedPalletAnalysis /> },
    { label: 'Flagged Modules Review', component: <FlaggedModulesReview /> },
    { label: 'Analysis', component: <Analysis /> },

  ];
 
  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={0}
      panelStyles={{ padding: '16px' }}
    />
  );
};
 
export default PdiTabsComponent;